import TokenVolatilityTimeSeriesChart from '../../../../../widgets/immersive/token-volatility-timeseries/token-volatility-timeseries-chart';

import './styles.scss';

const RealizedAndImpliedChart = () => {
  return (
    <div className="realized-and-implied-chart-container">
      <TokenVolatilityTimeSeriesChart />
    </div>
  );
};

export default RealizedAndImpliedChart;
